/**
 * Meldet den Service Worker an.
 *
 * Nur im Produktionsbau: Im Entwicklungsmodus überlagerte ein Worker den
 * Hot-Reload von Vite, und man debuggte eine Fassung, die man nicht
 * geschrieben hat.
 *
 * Schlägt die Anmeldung fehl, ist das kein Grund, die Anwendung anzuhalten.
 * Der Worker hält nichts vor (`public/sw.js`) – er trägt allein die
 * Installierbarkeit, und ohne ihn läuft die Anwendung im Browser weiter wie
 * bisher.
 */
export function meldeServiceWorkerAn(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((fehler: unknown) => {
      console.warn('Der Service Worker liess sich nicht anmelden.', fehler);
    });
  });
}
